import { useEffect } from "react";
import { AuthScreen } from "./screens/auth.tsx";
import { ChangesetList, ChangesetReview } from "./screens/changesets.tsx";
import { Billing } from "./screens/billing.tsx";
import { ConnectNudge, Connections } from "./screens/connections.tsx";
import { DataView } from "./screens/data.tsx";
import { Members } from "./screens/members.tsx";
import { Roles } from "./screens/roles.tsx";
import { Workflows } from "./screens/workflows.tsx";
import { NewPage, PageScreen } from "./screens/page.tsx";
import { NewStore } from "./screens/new-store.tsx";
import { match, navigate, onLink, useLocation } from "./lib/router.ts";
import { IlhaShell } from "./shell/shell.tsx";
import { SessionProvider, useSession } from "./lib/session.tsx";

export function App() {
  return (
    <SessionProvider signedOut={(onIn) => <AuthScreen onIn={onIn} />}>
      <Shell />
    </SessionProvider>
  );
}

function Shell() {
  const path = useLocation().pathname;
  const s = useSession();
  // Signed up but no store yet: step 3 of signing up, outside the app's shell.
  if (!s.tenant) return <NewStore first />;
  return (
    <IlhaShell path={path}>
      <Routes path={path} />
    </IlhaShell>
  );
}

function Routes({ path }: { path: string }) {
  const s = useSession();
  if (path === "/lojas/nova" || !s.tenant) return <NewStore first={false} />;
  let m: Record<string, string> | null;
  if ((m = match("/t/:page", path))) return <PageScreen key={`${s.tenant.id}:${m.page}`} name={m.page!} />;
  if (path === "/nova-tela") return <NewPage />;
  if ((m = match("/dados/:collection", path))) return <DataView key={`${s.tenant.id}:${m.collection}`} name={m.collection!} />;
  if (path === "/changesets") return <ChangesetList key={s.tenant.id} />;
  if ((m = match("/changesets/:id", path))) return <ChangesetReview key={m.id} id={m.id!} />;
  if (path === "/conexoes") return <Connections key={s.tenant.id} />;
  if (path === "/membros" && s.isOwner) return <Members key={s.tenant.id} />;
  if (path === "/papeis" && s.isStaff) return <Roles key={s.tenant.id} />;
  if (path === "/cobranca" && s.isOwner) return <Billing key={s.tenant.id} />;
  if (path === "/workflows" && s.isStaff) return <Workflows key={s.tenant.id} />;
  return <Home />;
}

function Home() {
  const s = useSession();
  const first = s.pages.find((p) => p.menu);
  useEffect(() => {
    if (first) navigate(`/t/${first.name}`, { replace: true });
  }, [first]);
  if (first) return null;
  return (
    <div className="stack" style={{ maxWidth: 640 }}>
      <div className="topbar">
        <h1>{s.tenant?.name}</h1>
      </div>
      <div className="card stack">
        <p style={{ margin: 0 }}>Esta loja ainda não tem telas.</p>
        <ConnectNudge />
        <p className="muted" style={{ margin: 0 }}>Ou crie as telas aqui mesmo, no construtor.</p>
        {s.canBuild && (
          <div>
            <a className="btn primary" href="/nova-tela" onClick={onLink} style={{ textDecoration: "none", display: "inline-block" }}>
              Criar uma tela
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
